var _rect, _rect2, _rect3, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPatientRecordIcon = function SvgPatientRecordIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 26.4999,
    height: 26.5027,
    rx: 5.97066,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 26.4999,
    height: 26.5027,
    rx: 5.97066,
    fill: "#F4FCFC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 26.4999,
    height: 26.5027,
    rx: 5.97066,
    stroke: "#5BD2DB",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6819 14.0014C20.6819 17.6917 17.6903 20.6832 13.9999 20.6832C10.3096 20.6832 7.318 17.6917 7.318 14.0014C7.318 10.3111 10.3096 7.31947 13.9999 7.31947C17.6903 7.31947 20.6819 10.3111 20.6819 14.0014Z",
    stroke: "#24C3CF",
    strokeWidth: 0.890923
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_7236)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2256 13.0891C17.2205 12.9748 17.1266 12.8832 17.0117 12.8832H15.1577V11.0297V11.0195C15.1531 10.9268 15.09 10.8465 15.0001 10.8221L13.1131 10.3027L13.1034 10.3004L13.0943 10.2987C12.9862 10.2788 12.8793 10.3453 12.8497 10.454C12.8446 10.4722 12.8423 10.4915 12.8423 10.5109V12.8832H10.9883L10.9786 12.8837C10.8648 12.8883 10.7744 12.9827 10.7744 13.0988V14.9039V14.9135C10.7795 15.0279 10.8734 15.1195 10.9883 15.1195H12.8423V17.4918C12.8423 17.5111 12.8446 17.5304 12.8497 17.5486C12.881 17.6636 12.9987 17.7313 13.1131 17.7L15.0001 17.1806C15.0934 17.155 15.1577 17.0702 15.1577 16.9729V15.1195H17.0117L17.0214 15.1189C17.1351 15.1138 17.2256 15.0194 17.2256 14.9039V13.0988V13.0891Z",
    fill: "#24C3CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_7236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.45122,
    height: 7.41242,
    fill: "white",
    transform: "translate(10.7744 10.2952)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPatientRecordIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "patient-record-icon.0f8c52905d1f4ac27349bd17e227bf37.svg";